import { render } from "./SelectQuestion.vue?vue&type=template&id=5790c823&scoped=true"
import script from "./SelectQuestion.vue?vue&type=script&lang=js"
export * from "./SelectQuestion.vue?vue&type=script&lang=js"

import "./SelectQuestion.vue?vue&type=style&index=0&id=5790c823&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5790c823"]])

export default __exports__